import React from 'react';
import { Collapse } from 'antd';
import './Collapse.scss';

const { Panel } = Collapse;

const MrphCollapse = props => {
  const { panels } = props;
  return (
    <Collapse className="collapseContainer" {...props}>
      {panels.map(item => {
        return (
          <Panel header={item.header} key={item.key} extra={item?.extra}>
            {item.content}
          </Panel>
        );
      })}
    </Collapse>
  );
};

export { MrphCollapse as Collapse };
